import service, { getdefaultURL } from '@/utils/disscussBoardRequest'

const baseUrl = getdefaultURL()

// 获取讨论区列表
export function getDiscussionList(params) {
  return service({
    url: baseUrl,
    method: 'get',
    params
  })
}
// 提交评论区留言
export function postDiscussion(params) {
  return service({
    url: baseUrl,
    method: 'post',
    params
  })
}
// 点赞评论
export function approvedDiscussion(params) {
  return service({
    url: `${baseUrl}/${params.id}/like`,
    method: 'post',
    params
  })
}
// 删除评论
export function deleteDiscussion(params) {
  return service({
    url: `${baseUrl}/${params.id}`,
    method: 'delete',
    params
  })
}
